import api from './api';

/**
 * Returns the best available image for an event:
 * 1. Event's own locandina
 * 2. Associated venue's logo (fallback)
 * 3. Empty string (caller will show placeholder)
 */
export function getEventImage(evento, locale) {
  if (!evento) return '';
  if (evento.locandina && String(evento.locandina).trim()) return evento.locandina;
  if (locale?.logo && String(locale.logo).trim()) return locale.logo;
  if (locale?.gallery?.length) return locale.gallery[0];
  return '';
}

/**
 * Track an event interaction on the backend (view/buy/table).
 * Fire-and-forget, never throws. Dedupes 'view' per session.
 */
export function trackEventBackend(slug, action) {
  if (!slug || !action) return;
  try {
    if (action === 'view') {
      const key = `tracked_view_${slug}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    }
    api.post(`/public/eventi/${slug}/track`, { action }).catch(() => {});
  } catch {
    // sessionStorage might be unavailable - still try the call
    api.post(`/public/eventi/${slug}/track`, { action }).catch(() => {});
  }
}
